export default __webpack_public_path__ + "_/images/logos/egb-logo-9ccd821690a1b5850066fabc3671d6099ae40fb5808f5c0268ae80edf6883c9d.svg";